import { render, staticRenderFns } from "./MilkDisposal.vue?vue&type=template&id=6e469003&scoped=true&"
import script from "./MilkDisposal.vue?vue&type=script&lang=js&"
export * from "./MilkDisposal.vue?vue&type=script&lang=js&"
import style0 from "./MilkDisposal.vue?vue&type=style&index=0&id=6e469003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e469003",
  null
  
)

export default component.exports